export default __webpack_public_path__ + "static/media/07.742da60d.jpg";